import styled from "styled-components";

import Colors from "@constants/Colors";
import { FormControl, Select } from "@mui/material";

export const StyledDropdown = styled(Select)`
  border-radius: 8px !important;
  font-family: "Ringside Regular-Bold" !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  line-height: 20px !important;
  min-width: 117px !important;
  & .MuiSelect-select.MuiInputBase-input.MuiOutlinedInput-input {
    padding: 10px 38px 10px 16px !important;
    border-radius: 8px !important;
    border: 1px solid ${Colors.secondary} !important;
  }
`;

export const StyledFormControl = styled(FormControl)`
  margin: 0px !important;
  height: 40px !important;
  & .MuiOutlinedInput-notchedOutline {
    border: 1px solid ${Colors.secondary} !important;
  }
  & .MuiSelect-icon {
    top: calc(50% - 0.6em);
    height: 20px !important;
    width: 20px !important;
  }
`;
